import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronRightOutlinedSize12Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m8.625 6-3.75 3.75-.742-.742L7.14 6 4.132 2.992l.743-.742z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChevronRightOutlinedSize12Glyph.displayName = 'ChevronRightOutlinedSize12Glyph';
